import { Link } from '@zoomit/primitives';
import { OriginURL } from '@zoomit/web-kit';

export const ErrorPages = () =>
  new Map([
    [
      '404',
      {
        errorCodeTitle: '404',
        errorTitle: 'صفحه ای که دنبالش بودی پیدا نشد',
        errorHeadTitle: 'خطای ۴۰۴ - صفحه یافت نشد',
        errorDescription: () => (
          <>
            برای پیدا کردن مسیر درست می توانی سری به{' '}
            <Link className="text-text-hover text-h5 font-normal" href={`${OriginURL}/product/`}>
              صفحه اول زوبین
            </Link>{' '}
            سر بزنی
          </>
        ),
      },
    ],
    [
      '500',
      {
        errorCodeTitle: '500',
        errorTitle: 'مشکلی برای سرور به وجود اومده!',
        errorHeadTitle: 'خطای 500 - صفحه یافت نشد',
        errorDescription: () => (
          <>
            لطفا چند دقیقه دیگر به{' '}
            <Link className="text-h5 text-text-hover mx-1.5 font-normal" href={`${OriginURL}/product/`}>
              زوبین
            </Link>{' '}
            سر بزن
          </>
        ),
      },
    ],
    [
      'general-error',
      {
        errorTitle: 'اوه… خطایی رخ داده!',
        errorHeadTitle: 'خطای کلی - صفحه یافت نشد',
        errorDescription: () => (
          <>
            خطایی بصورت ناخواسته پیش آمده، صفحه رو یکبار ریفرش کن یا <br /> چند دقیقه دیگه به زوبین سر بزن
          </>
        ),
      },
    ],
  ]);
